import React from "react";
import { useSelector } from "react-redux";
import TheHeader from "./comm/TheHeader";
import ApiHelper from "src/utils/api/api_helper";
import {
  CContainer,
  CCardBody,
  CListGroup,
  CListGroupItem,
} from "@coreui/react";
import TheNav from "./comm/TheNav";
import TheFooter from "./comm/TheFooter";

const InfoPage = () => {
  const state = useSelector((state) => state.main);
  const [docs, setDocs] = React.useState([]);
  const param = { taskNo: state.taskNo };

  React.useEffect(() => {
    ApiHelper.request(
      ApiHelper.methods.post,
      "/cust/request/sbmsDocList",
      param
    )
      .then(({ data }) => {
        if (data.status === "SUCCESS") {
          let result = data.data;
          setDocs(result);
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }, []);

  return (
    <>
      <TheHeader />
      <div className="c-main">
        <TheNav step={state.step} />
        <CContainer>
          <h5>
            <b>
              {state.cntrYn !== '0' && '위촉계약서 및 '}보험사별 위촉서류 작성을 위해 준비할 내용입니다.
            </b>
          </h5>
          <h6 className="warningText">
            <b>사전에 준비하셔서 본 시스템에서 업로드하시면 됩니다.</b>
          </h6>
          {/* 메가인포는 파일 삭제하고 있지 않아 제외 */}
          { state.corpNo != '45' &&
            <h6 className="reUploadText">
              <b>* 업로드 후 3개월이 초과된 파일은 재업로드가 필요하니 확인 후 진행해주세요.</b>
            </h6>
          }
        </CContainer>
        <CCardBody className="bottom-card-body">
          <CListGroup>
            {docs.length
              ? docs.map((doc) => {
                let sbmsDocNm = doc.SBMS_DOC_NM;
                let splitted = sbmsDocNm.split("\r\n");
                return (
                  <CListGroupItem
                    className="infoListItem"
                    key={doc.SBMS_DOC_NO}
                  >
                    { sbmsDocNm.includes("\r\n") ?     
                      splitted.map((item, index) => (
                      <div key={index}>{item}</div>
                      ))
                    : sbmsDocNm

                    }  
                  </CListGroupItem>
                );
              })
              : <CListGroupItem
                  className="infoListItem"
                >
                  해당업무에는 별도로 준비할 내용이 없습니다.
                </CListGroupItem>}
          </CListGroup>
        </CCardBody>
      </div>
      <TheFooter step={state.step} />
    </>
  );
};

export default InfoPage;
